import { render, staticRenderFns } from "./SectionLayout.vue?vue&type=template&id=e7c928ea&"
import script from "./SectionLayout.vue?vue&type=script&lang=js&"
export * from "./SectionLayout.vue?vue&type=script&lang=js&"
import style0 from "./SectionLayout.vue?vue&type=style&index=0&id=e7c928ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports